import { Chip } from '@mui/material';
import PropTypes from 'prop-types';

import colors from 'common/constants/colors';

// POM-6600 — the Product ID in the top-right corner of every product card on Add Inventory Item, so
// products can be compared by ID at a glance.
const ProductIdChip = ({ productId }) => (
  <Chip
    size='small'
    variant='outlined'
    label={productId || '—'}
    data-testid='product-id-chip'
    sx={{
      flexShrink: 0,
      fontWeight: 700,
      letterSpacing: '0.02em',
      color: 'primary.main',
      bgcolor: 'background.paper',
      borderColor: colors.selectedProductNavyTintBorder,
    }}
  />
);

ProductIdChip.propTypes = {
  productId: PropTypes.string,
};
ProductIdChip.defaultProps = {
  productId: undefined,
};

export default ProductIdChip;
